import { ResizeDirectionEnum } from '../types';
import { Scene } from '@/player-config/src/types/RemotionPlayerConfigTypes/Scene';
export const VOLUME_MIN = 0;
export const VOLUME_MAX = 200;

export const validateAndNormalizeVolume = (value: number | string): number => {
  let numericValue: number;

  if (typeof value === 'string') {
    numericValue = parseInt(value, 10);
  } else {
    numericValue = value;
  }

  if (isNaN(numericValue)) {
    return 0;
  }

  return Math.max(VOLUME_MIN, Math.min(VOLUME_MAX, numericValue));
};

export const removeLeadingZeros = (value: string): string => {
  if (value === '0') {
    return '0';
  }

  return value.replace(/^0+/, '') || '0';
};

export const getCursor = (direction: ResizeDirectionEnum) => {
  let cursor = '';
  if (direction.includes('top')) {
    cursor += 'n';
  }
  if (direction.includes('bottom')) {
    cursor += 's';
  }
  if (direction.includes('left')) {
    cursor += 'w';
  }
  if (direction.includes('right')) {
    cursor += 'e';
  }
  return cursor + '-resize';
};

export const getCropPositions = (
  scene: Scene,
  selectedVideoId: string,
  parentContainerAspectRatio: number,
  videoAspectRatio: number
) => {
  const oldCropPositions = scene.details.video_crop_position_map?.[selectedVideoId];
  if (!oldCropPositions) {
    const shouldFitByWidth = parentContainerAspectRatio > videoAspectRatio;
    if (shouldFitByWidth) {
      return {
        left: 0,
        top: 0.5 - (0.5 * videoAspectRatio) / parentContainerAspectRatio,
        width: 1,
        height: (1 * videoAspectRatio) / parentContainerAspectRatio
      };
    }
    return {
      top: 0,
      left: 0.5 - (0.5 * parentContainerAspectRatio) / videoAspectRatio,
      width: (1 * parentContainerAspectRatio) / videoAspectRatio,
      height: 1
    };
  }
  return {
    left: oldCropPositions.top_left.x || 0,
    top: oldCropPositions.top_left.y || 0,
    width: oldCropPositions.bottom_right.x - oldCropPositions.top_left.x || 1,
    height: oldCropPositions.bottom_right.y - oldCropPositions.top_left.y || 1
  };
};
